export default __webpack_public_path__ + "static/media/home-activities-networking.d4cf530f.png";